export const FETCH_TABLE_START = "FETCH_TABLE_START";
export const FETCH_TABLE_SUCCESS = "FETCH_TABLE_SUCCESS";
export const FETCH_TABLE_FAIL = "FETCH_TABLE_FAIL";

export const EDIT_TABLE_START = "EDIT_TABLE_START";
export const EDIT_TABLE_SUCCESS = "EDIT_TABLE_SUCCESS";
export const EDIT_TABLE_FAIL = "EDIT_TABLE_FAIL";

export const SET_WORKORDER_CURRENT_PAGE = "SET_WORKORDER_CURRENT_PAGE";

export const SET_WORKORDER_PAGE_SIZE = "SET_WORKORDER_PAGE_SIZE";

export const SET_FILTERS = "SET_FILTERS";

export const SET_WORKORDER_SEARCH = "SET_WORKORDER_SEARCH";

export const UNASSIGN_PARTS = "UNASSIGN_PARTS";

export const RESET_WORK_ORDER = "RESET_WORK_ORDER";

export const SET_SEARCH_CONTEXT = "SET_SEARCH_CONTEXT";

export const RESET_FILTERS = "RESET_FILTERS";
